import { fork, call, put, select, takeLatest, all } from 'redux-saga/effects';

import {
    fetchApplication,
    fetchContext,
    putApplication,
    requestLoginLink,
    fetchProfile,
    fetchFormalIndicativeOffers,
    postThreatmetrix,
    putThreatmetrix,
    getCustomerStateEdge,
    putCustomerStateEdge,
    getTruelayerURL,
    fetchOffers,
    selectOffer,
    fetchQualifiedLeadType,
    getDocumentFeedback
} from './lendingAPI';
import {
    GET_CUSTOMER_STATE_EDGE,
    PUT_CUSTOMER_STATE_EDGE,
    GET_TRUELAYER_URL,
    GET_OFFERS,
    POST_SELECT_OFFER,
    GET_QUALIFIED_LEAD,
    GET_DOCUMENT_FEEDBACK
} from './lendingAPI.actions';
import { getInitialApplicationStateFetcher } from '../utils/Api';

export type StateKeyType = {
    isImpersonating?: boolean;
    stateKey: string;
};
function* lendingAPIWorker() {
    yield all([
        fork(lendingAPIWorkerFactory('GET_CONTEXT', fetchContext)),
        fork(lendingAPIWorkerFactory('GET_APPLICATION', fetchApplication)),
        fork(lendingAPIWorkerFactory('PUT_APPLICATION', putApplication)),
        fork(lendingAPIWorkerFactory(GET_OFFERS, fetchOffers)),
        fork(
            lendingAPIWorkerFactory(
                'GET_CUSTOMER_STATE',
                getInitialApplicationStateFetcher
            )
        ),
        fork(
            lendingAPIWorkerFactory(
                GET_CUSTOMER_STATE_EDGE,
                getCustomerStateEdge
            )
        ),
        fork(
            lendingAPIWorkerFactory(
                PUT_CUSTOMER_STATE_EDGE,
                putCustomerStateEdge
            )
        ),
        fork(
            lendingAPIWorkerFactory('POST_REQUEST_LOGIN_LINK', requestLoginLink)
        ),
        fork(lendingAPIWorkerFactory('POST_THREATMETRIX', postThreatmetrix)),
        fork(lendingAPIWorkerFactory('PUT_THREATMETRIX', putThreatmetrix)),
        fork(lendingAPIWorkerFactory('GET_PROFILE', fetchProfile)),
        fork(
            lendingAPIWorkerFactory(
                'GET_FORMAL_INDICATIVE_OFFERS',
                fetchFormalIndicativeOffers
            )
        ),

        fork(lendingAPIWorkerFactory(GET_TRUELAYER_URL, getTruelayerURL)),
        fork(
            lendingAPIWorkerFactory(GET_DOCUMENT_FEEDBACK, getDocumentFeedback)
        ),
        fork(lendingAPIWorkerFactory(POST_SELECT_OFFER, selectOffer)),
        fork(
            lendingAPIWorkerFactory(GET_QUALIFIED_LEAD, fetchQualifiedLeadType)
        )
    ]);
}

function lendingAPIWorkerFactory(apiAction: string, fetcher: any) {
    return function* () {
        yield takeLatest(`api/${apiAction}`, function* (action) {
            yield put({ type: `api/${apiAction} [pending]` });

            try {
                const stateKey: StateKeyType = yield select(
                    ({ lendingAPI }) => ({
                        isImpersonating: !!lendingAPI.impersonatingStateKey,
                        stateKey:
                            lendingAPI.impersonatingStateKey ||
                            lendingAPI.stateKey
                    })
                );

                // we should be able to call these endpoints without statekey
                if (
                    stateKey.stateKey === null &&
                    ![
                        'GET_CONTEXT',
                        'GET_PROFILE',
                        'POST_REQUEST_LOGIN_LINK',
                        GET_QUALIFIED_LEAD,
                        GET_OFFERS,
                        POST_SELECT_OFFER
                    ].includes(apiAction)
                ) {
                    throw new Error('stateKey is required and not defined');
                }

                const response: { data: object } = yield call(
                    fetcher,
                    stateKey,
                    action
                );

                yield put({
                    type: `api/${apiAction} [success]`,
                    payload: response?.data
                });
            } catch (e) {
                if (e instanceof Error) {
                    yield put({
                        type: `api/${apiAction} [fail]`,
                        payload: e.message
                    });
                }
            }
        });
    };
}

export default fork(lendingAPIWorker);
